module.exports = __webpack_public_path__ + "images/waitingfa465bd4e83a69b3d8d95bd05b9b16cf.svg";